/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Step_UpInputs */

const en_editor_step_up = /** @type {(inputs: Editor_Step_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move up`)
};

const de_editor_step_up = /** @type {(inputs: Editor_Step_UpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach oben`)
};

/**
* | output |
* | --- |
* | "Move up" |
*
* @param {Editor_Step_UpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_step_up = /** @type {((inputs?: Editor_Step_UpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Step_UpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_step_up(inputs)
	return en_editor_step_up(inputs)
});